'use strict';

var assertion = require('./assertion');
var assertType = assertion.assertType;


/**
 * Asserts parameter type of a canonical number and type casts it into a Number
 * Disallows empty string and NaN
 * Used by Node
 */
function assertCanonicalNumberTypeStrict(parameterValue, parameterName) {
    var number = parameterValue;
    assertType(
        parameterValue,
        parameterName,
        [],
        {
            // if number, should not be NaN
            // if string, cast to Number and should not be NaN
            condition: (typeof parameterValue === 'number' && !isNaN(parameterValue)) ||
            (typeof parameterValue === 'string' && parameterValue !== '' && !isNaN(number = Number(parameterValue))),
            errorMessage: 'Parameter `{parameterName}` must be a number or a string representing a canonical number (e.g, `"9999.99"`), not {parameterType} `{{parameterValue}}`'
        }
    );
    return number;
}

/**
 * Asserts parameter type of a canonical number and type casts it into a Number
 * Disallows empty string but allows NaN
 * Used by client
 */
function assertCanonicalNumberType(parameterValue, parameterName) {
    var number = parameterValue;
    assertType(
        parameterValue,
        parameterName,
        [],
        {
            // if string, cast to Number and result should not be NaN
            condition: typeof parameterValue === 'number' ||
            (typeof parameterValue === 'string' && parameterValue !== '' && !isNaN(number = Number(parameterValue))),
            errorMessage: 'Parameter `{parameterName}` must be a number or a string representing a canonical number (e.g, `"9999.99"`), not {parameterType} `{{parameterValue}}`'
        }
    );
    return number;
}

/**
 * Asserts parameter type of a localized number.
 */
function assertLocalizedNumberType(parameterValue, parameterName) {
    assertType(
        parameterValue,
        parameterName,
        ['number', 'string'],
        {
            errorMessage: 'Parameter `{parameterName}` must be a number or a string representing a localized number (e.g., `"9,999.99"` in English or `"9.999,99"` in Spanish), not {parameterType} `{{parameterValue}}`'
        }
    );
}

/**
 * Sets minimumFractionDigits/maximumFractionDigits in options:
 *
 * If either is undefined, currencyDigits is used (if provided)
 * Otherwise, minimumFractionDigits defaults to 0, and maximumFractionDigits defaults to 9
 * And if minimumFractionDigits is greater than maximumFractionDigits,
 * then minimumFractionDigits is reduced to the same level as maximumFractionDigits
 */
function setFractionDigits(options, currencyDigits) {
    // TODO: Use Globalize formatCurrency, which handles currency defaultDigits itself
    if (options.minimumFractionDigits === undefined) {
        options.minimumFractionDigits = (currencyDigits === undefined) ? 0 : currencyDigits;
    }
    if (options.maximumFractionDigits === undefined || options.maximumFractionDigits > 9) {
        options.maximumFractionDigits = (currencyDigits === undefined) ? 9 : currencyDigits;
    }
    if (options.minimumFractionDigits > options.maximumFractionDigits) {
        options.minimumFractionDigits = options.maximumFractionDigits;
    }
    return options;
}

module.exports = {
    assertCanonicalNumberType: assertCanonicalNumberType,
    assertCanonicalNumberTypeStrict: assertCanonicalNumberTypeStrict,
    assertLocalizedNumberType: assertLocalizedNumberType,
    setFractionDigits: setFractionDigits
};



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/griffin-paypal/lib/client/utils/numberHelpers.js
// module id = 349
// module chunks = 6